import React from 'react';
import PropTypes from 'prop-types';
import {
  convertTimePartToString,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/TimeUtility';
import { TIME_SELECTOR_HOURS } from '../../../../../../hooks/useQuietTimes/useQuietTimes';
// import timePeriodPropType from '../../../../../utility/PropTypes/timePeriodPropType';

function TimePartSelect({
  periodBoundary,
  timeUnit,
  currentBoundaryTimePart,
  onTimePeriodChange,
}) {
  const timeValueList = [];
  const upperBound = timeUnit === TIME_SELECTOR_HOURS ? 24 : 60;
  for (let i = 0; i < upperBound; i += 1) {
    timeValueList.push(convertTimePartToString(i));
  }
  return (
    <select
      className="form-control form-control-sm my-1"
      aria-label="select time period"
      name={periodBoundary + timeUnit}
      value={currentBoundaryTimePart}
      onChange={(e) => onTimePeriodChange(periodBoundary, timeUnit, e)}
    >
      {timeValueList.map((timePart, index) => (
        <option key={`time-part-${index}`} value={index}>
          {timePart}
        </option>
      ))}
    </select>
  );
}
TimePartSelect.propTypes = {
  // timePeriod: PropTypes.shape(timePeriodPropType).isRequired,
  periodBoundary: PropTypes.number.isRequired,
  timeUnit: PropTypes.string.isRequired,
  currentBoundaryTimePart: PropTypes.number.isRequired,
  onTimePeriodChange: PropTypes.func.isRequired,
};
export default TimePartSelect;
